import ApprovalcenterList from './list.vue'
import ApprovaldetailsList from './approvaldetails.vue'


let a = Object.assign({ ApprovalcenterList, ApprovaldetailsList },)
export default a